import {Component, Input, OnInit} from '@angular/core';
import {AuthService} from '@sicapes/auth';
import {PessoaService} from '../../shared/service/corporativo/pessoa.service';
import {LocalStorageService} from '../../shared/service/local-storage.service';
import {limparCacheIndicacaoVagas} from '../../shared/service/scppg/scppg-programa.helper';
import {environment} from '../../../environments/environment';
import {environmentDes} from '../../../environments/environment.des';
import {environmentHom} from '../../../environments/environment.hom';
import {environmentReview} from '../../../environments/environment.review';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
    @Input() userData: any;
    visibleSidebar;
    URL_API_BERTHA: any;
    displaySimulator = false;
    constructor(private authService: AuthService, public pessoaService: PessoaService, private localStorageService: LocalStorageService) {
        let env = environment;
        const hostname = window && window.location && window.location.hostname;
        if (/^sicapes-individual-des.apps-dht.capesocp.capes.gov.br/.test(hostname)) {
            env = environmentDes;
        } else if (/^sicapes-individual-hom.apps-dht.capesocp.capes.gov.br/.test(hostname)) {
            env = environmentHom;
        } else if (/^(sicapes-individual-)(.*)(feature-[\d\w-]*)(.apps-dht.capesocp.capes.gov.br)/.test(hostname)) {
            env = environmentReview;
        }
        this.URL_API_BERTHA  = env.URL_API_BERTHA;
    }

    ngOnInit(): void {
    }

    isGestorInscricao(): boolean {
        return this.userData.roles !== null && this.userData.roles.includes('GESTOR SICAPES 3');
    }

    isSimulando(): boolean {
        return !!(this.userData && this.userData.pessoaLogada);
    }

    logout(): void {
        // Limpa dados escopados por usuário (indicação de vagas) para não vazar
        // para o próximo login no mesmo navegador.
        limparCacheIndicacaoVagas(prefixo => this.localStorageService.removeByPrefix(prefixo));
        this.authService.logout();
    }
}
